import { useParams } from "react-router-dom";
import { ContainerProduct } from "../styles/Layout.style";
import MenuProduct from "../components/MenuProduct/MenuProduct";
import ContentProduct from "../components/ContentProduct/ContentProduct";
import ProductBanner from "../components/ProductBanner/ProductBanner";

const Product = () => {
  const { productId } = useParams();
  const { lineId } = useParams();

    return (
        <>
        <ProductBanner />
        <ContainerProduct>
            
            <MenuProduct />
            <ContentProduct />
        </ContainerProduct>
        </>
    );
}

export default Product;